import React from 'react'

function TestMaster() {
  return (
    <div>"Test Master (X-ray, MRI, blood test, etc.)</div>
  )
}

export default TestMaster